<div
  class="form-field-draggable widget-card-background widget-content"
  cdkDrag
  [cdkDragDisabled]="!editable"
  [class.field-edit-container]="
    fieldType().controlType === FieldType.SECTION_SUMMARY
  "
>
  <div class="p-3 mb-2">
    <div class="d-flex flex-row">
      <div>
        <ng-icon
          class="field-icon"
          [name]="fieldType().icon"
          size="1.125rem"
        ></ng-icon>
      </div>

      <ng-content></ng-content>

      <div
        class="text-end"
        [ngbTooltip]="cannotEditMessageKey | translate"
        [disableTooltip]="editable"
      >
        <ng-icon
          name="matDragIndicator"
          class="pointer-cursor text-secondary"
          cdkDragHandle
        ></ng-icon>
      </div>
    </div>

    <div class="mt-2 d-flex flex-row justify-content-end">
      <button
        class="btn p-0 font-size-base text-medium-gray pe-2 border-end rounded-0"
        (click)="openSettingsDialog(field()?.key ?? '')"
        translate
      >
        Edit & Settings
      </button>

      <span
        ngbTooltip="{{ cannotEditMessageKey | translate }}"
        [disableTooltip]="editable"
        class="d-inline-block"
      >
        <button
          class="btn p-0 font-size-base text-primary ps-2 border-none"
          (click)="deleteField(field().key ?? '')"
          [disabled]="!editable"
          translate
        >
          Interaction.Delete
        </button>
      </span>
    </div>
  </div>

  <div
    class="d-none"
    *cdkDragPreview
  ></div>
  <app-field-type-drag-placeholder [fieldType]="fieldType()" />
</div>
